import { render, staticRenderFns } from "./LgbtqPicker.vue?vue&type=template&id=f4b0ab9e&"
import script from "./LgbtqPicker.vue?vue&type=script&lang=js&"
export * from "./LgbtqPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports